import dayjs from "dayjs";

export default (date, formatString = "MMMM DD, YYYY hh:mm a") => {
  return date ? dayjs(date).format(formatString) : "—";
};
